const r = (t, o) => {
  let e;
  return function(...s) {
    const c = () => {
      clearTimeout(e), t(...s);
    };
    clearTimeout(e), e = setTimeout(c, o);
  };
}, u = typeof process == "object" && process && process.env && process.env.UNIT_TESTING_ENV;
export {
  r as d,
  u as i
};
